import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import Scene from '../three/Scene';
import Environment from '../three/Environment';
import MultiCharactersContainer from './MultiCharactersContainer';
import { useSimulationContext } from '../../providers/SimulationProvider';

/**
 * ThreeCanvas for a multi-character simulation: same scene and environment,
 * with every character rendered against the shared agent client.
 */
function MultiCharacterThreeCanvas({ client, talkingBotId, emotionsByBotId }) {
  const { isClientInitialized } = useSimulationContext();

  return (
    <Canvas className={`${isClientInitialized ? 'opacity-100' : 'opacity-0'}`}>
      <Suspense>
        <group>
          <Scene />
          <Environment />
          <MultiCharactersContainer
            client={client}
            talkingBotId={talkingBotId}
            emotionsByBotId={emotionsByBotId}
          />
        </group>
      </Suspense>
    </Canvas>
  );
}

export default MultiCharacterThreeCanvas;
